import {
  CheckboxField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  arrayPush,
  change,
  Field,
  FieldArray,
  formValueSelector,
  isDirty,
  reset,
  resetSection,
} from "redux-form"
import { renderBlackOutDates, renderWeeklyHours } from "./utils"
import UnsavedAlertModal from "components/UnsavedAlertModal"

const AvailabilityTab = ({
  arrayPush,
  availabilityFormValues,
  change,
  resetSection,
  handleSave,
  tabIsActive,
  resetForm,
  isDirty,
  selectedSubCalendar,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  const durationOptions = [
    { value: 10, label: "10 min" },
    { value: 15, label: "15 min" },
    { value: 20, label: "20 min" },
    { value: 30, label: "30 min" },
    { value: 45, label: "45 min" },
    { value: 60, label: "1 hour" },
    { value: 90, label: "1 1/2 hours" },
    { value: 120, label: "2 hours" },
    { value: 180, label: "3 hours" },
    { value: 240, label: "4 hours" },
    { value: 300, label: "5 hours" },
    { value: 360, label: "6 hours" },
    { value: 420, label: "7 hours" },
    { value: 480, label: "8 hours" },
    { value: 720, label: "12 hours" },
    { value: 1440, label: "24 hours" },
  ]

  const renderUnavailableDay = (day, checkboxField) => {
    return (
      <>
        <Col xs="auto" style={{ minWidth: "368px" }} className="mt-2">
          Unavailable
        </Col>
        <Col xs="auto" className="mt-2">
          <i
            className="bx bx-sm bx-plus"
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              arrayPush(`availability.${day}`, {
                start: "09:00:00",
                end: "17:00:00",
              })
              change(`availability.${checkboxField}`, true)
            }}
          />
        </Col>
      </>
    )
  }

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>SET AVAILABILITY</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-2" style={{ minWidth: "290px" }}>
              <label>Duration:</label>
            </Col>
            <Col xs="auto">
              <div style={{ minWidth: "185px" }}>
                <Field
                  name="duration"
                  component={SingleSelectField}
                  options={durationOptions}
                  isSearchable={false}
                  // disabled={!!selectedSubCalendar}
                />
              </div>
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                component={CheckboxField}
                name="hideEndTime"
                label="Do not show end time"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2" style={{ minWidth: "290px" }}>
              <label>Number of attendees or seats:</label>
            </Col>
            <Col xs="auto">
              <Field
                name="attendees"
                component={TextField}
                min="1"
                type="number"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2">
              <label>Number of maximum seats per booking:</label>
            </Col>
            <Col xs="auto">
              <Field
                name="maxSeats"
                component={TextField}
                min="1"
                type="number"
              />
            </Col>
          </Row>
          <Row>
            <Col xs="auto" className="mt-2" style={{ minWidth: "290px" }}>
              <label>Book max days in advance: </label>
            </Col>
            <Col xs="auto">
              <Field
                name="maxDaysInAdvance"
                component={TextField}
                type="number"
                min="0"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <label>Set your weekly hours:</label>
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" style={{ minWidth: "73px" }} className="mt-2">
              <Field
                component={CheckboxField}
                name="sun"
                label="SUN"
                onChange={(event, value) => {
                  if (!value) {
                    resetSection("sunday")
                  } else {
                    arrayPush(`availability.sunday`, {
                      start: "09:00:00",
                      end: "17:00:00",
                    })
                  }
                }}
              />
            </Col>
            {availabilityFormValues?.sunday?.length === 0 ||
            !availabilityFormValues?.sun ? (
              renderUnavailableDay("sunday", "sun")
            ) : (
              <Col xs="auto">
                <FieldArray
                  name="sunday"
                  component={renderWeeklyHours}
                  changeCheckboxValue={() => {
                    change(`availability.sun`, false)
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="my-4">
            <Col xs="auto" style={{ minWidth: "73px" }} className="mt-2">
              <Field
                component={CheckboxField}
                name="mon"
                label="MON"
                onChange={(event, value) => {
                  if (!value) {
                    resetSection("monday")
                  } else {
                    arrayPush(`availability.monday`, {
                      start: "09:00:00",
                      end: "17:00:00",
                    })
                  }
                }}
              />
            </Col>
            {availabilityFormValues?.monday?.length === 0 ||
            !availabilityFormValues?.mon ? (
              renderUnavailableDay("monday", "mon")
            ) : (
              <Col xs="auto">
                <FieldArray
                  name="monday"
                  component={renderWeeklyHours}
                  changeCheckboxValue={() => {
                    change(`availability.mon`, false)
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="my-4">
            <Col xs="auto" style={{ minWidth: "73px" }} className="mt-2">
              <Field
                component={CheckboxField}
                name="tue"
                label="TUE"
                onChange={(event, value) => {
                  if (!value) {
                    resetSection("tuesday")
                  } else {
                    arrayPush(`availability.tuesday`, {
                      start: "09:00:00",
                      end: "17:00:00",
                    })
                  }
                }}
              />
            </Col>
            {availabilityFormValues?.tuesday?.length === 0 ||
            !availabilityFormValues?.tue ? (
              renderUnavailableDay("tuesday", "tue")
            ) : (
              <Col xs="auto">
                <FieldArray
                  name="tuesday"
                  component={renderWeeklyHours}
                  changeCheckboxValue={() => {
                    change(`availability.tue`, false)
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="my-4">
            <Col xs="auto" style={{ minWidth: "73px" }} className="mt-2">
              <Field
                component={CheckboxField}
                name="wed"
                label="WED"
                onChange={(event, value) => {
                  if (!value) {
                    resetSection("wednesday")
                  } else {
                    arrayPush(`availability.wednesday`, {
                      start: "09:00:00",
                      end: "17:00:00",
                    })
                  }
                }}
              />
            </Col>
            {availabilityFormValues?.wednesday?.length === 0 ||
            !availabilityFormValues?.wed ? (
              renderUnavailableDay("wednesday", "wed")
            ) : (
              <Col xs="auto">
                <FieldArray
                  name="wednesday"
                  component={renderWeeklyHours}
                  changeCheckboxValue={() => {
                    change(`availability.wed`, false)
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="my-4">
            <Col xs="auto" style={{ minWidth: "73px" }} className="mt-2">
              <Field
                component={CheckboxField}
                name="thu"
                label="THU"
                onChange={(event, value) => {
                  if (!value) {
                    resetSection("thursday")
                  } else {
                    arrayPush(`availability.thursday`, {
                      start: "09:00:00",
                      end: "17:00:00",
                    })
                  }
                }}
              />
            </Col>
            {availabilityFormValues?.thursday?.length === 0 ||
            !availabilityFormValues?.thu ? (
              renderUnavailableDay("thursday", "thu")
            ) : (
              <Col xs="auto">
                <FieldArray
                  name="thursday"
                  component={renderWeeklyHours}
                  changeCheckboxValue={() => {
                    change(`availability.thu`, false)
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="my-4">
            <Col xs="auto" style={{ minWidth: "73px" }} className="mt-2">
              <Field
                component={CheckboxField}
                name="fri"
                label="FRI"
                onChange={(event, value) => {
                  if (!value) {
                    resetSection("friday")
                  } else {
                    arrayPush(`availability.friday`, {
                      start: "09:00:00",
                      end: "17:00:00",
                    })
                  }
                }}
              />
            </Col>
            {availabilityFormValues?.friday?.length === 0 ||
            !availabilityFormValues?.fri ? (
              renderUnavailableDay("friday", "fri")
            ) : (
              <Col xs="auto">
                <FieldArray
                  name="friday"
                  component={renderWeeklyHours}
                  changeCheckboxValue={() => {
                    change(`availability.fri`, false)
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="my-4">
            <Col xs="auto" style={{ minWidth: "73px" }} className="mt-2">
              <Field
                component={CheckboxField}
                name="sat"
                label="SAT"
                onChange={(event, value) => {
                  if (!value) {
                    resetSection("saturday")
                  } else {
                    arrayPush(`availability.saturday`, {
                      start: "09:00:00",
                      end: "17:00:00",
                    })
                  }
                }}
              />
            </Col>
            {availabilityFormValues?.saturday?.length === 0 ||
            !availabilityFormValues?.sat ? (
              renderUnavailableDay("saturday", "sat")
            ) : (
              <Col xs="auto">
                <FieldArray
                  name="saturday"
                  component={renderWeeklyHours}
                  changeCheckboxValue={() => {
                    change(`availability.sat`, false)
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="mt-3">
            <Col xs="auto">
              <label>Blackout dates:</label>
            </Col>
          </Row>
          <Row>
            <Col>
              <Field name="blackoutDates" component={renderBlackOutDates} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.SUB_CALENDARS)

const mapStateToProps = state => ({
  availabilityFormValues: selector(state, "availability"),
  isDirty: isDirty(FORM_NAMES.SUB_CALENDARS)(state, ...["availability"]),
  selectedSubCalendar: state.BookingsFeature.selectedSubCalendar,
})

const mapDispatchToProps = dispatch => ({
  arrayPush: (field, values) =>
    dispatch(arrayPush(FORM_NAMES.SUB_CALENDARS, field, values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.SUB_CALENDARS, `${field}`, value)),
  resetSection: section =>
    dispatch(
      resetSection(FORM_NAMES.SUB_CALENDARS, ...[`availability.${section}`])
    ),
  resetForm: () => dispatch(reset(FORM_NAMES.SUB_CALENDARS)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityTab)
